import { useState } from 'react';
import classes from './ApplyBasicDivision.module.css'
import { useDispatch, useSelector } from 'react-redux';
import WarningPopup from '../../shared/WarningPopup/WarningPopup';
import { lessonParticipantsApi, messagesApi } from '../../../../../../utils';
import { throwApiError } from '../../../../../lms-shared/store/error-handling-actions';
import { useNavigate, useParams } from 'react-router-dom';
import LessonsList from './LessonsList';
import ProblematicList from './ProblematicList';
import * as PathRouter from '../../../../../../models/PathRoute'
import { submissionStatusTextEnum } from "../../../../../../models/SubmissionStatusEnum";
import { cretaeMessageContent } from '../../../../../lms-shared/functions/Message';
import { ObjectTypeNamesEnum } from '../../../../../../models/ObjectTypeEnum';
import warnIcon from '../../../../../../assests/learning-tracking/teams/warn.png'



const ApplyBasicDivision = ({ setPopup, setLoading, lessonMode, fetchTeams, teams, users, anableBasicDivisionButton, setAnableBasicDivisionButton, setDisplayLastChange, hasUsersInTeams }) => {

  const ApplyBasicDivisionStepsEnum = {
    lessonList: 0,
    lessonsWithNoBasicDivision: 1
  }

  const dispatch = useDispatch()
  const baseDispatch = useDispatch();
  const navigate = useNavigate()
  const { texts } = useSelector(state => state.translate);
  const { lessonByTopic } = useSelector(state => state.topics);
  const { homeUrl } = useSelector(state => state.application);
  const { user } = useSelector(state => state.auth);
  const courses = useSelector(state => state.courses.courses);
  const applicationId = useSelector(state => state.application.applicationId);
  const uiData = useSelector((state) => state.general.uiData);
  const { id, guid, applictionName } = useParams();
  const studyGroupId = id, lessonId = guid
  const [currentStep, setCurrentStep] = useState()
  const [unSuccsesList, setUnSuccsesList] = useState()
  const [basicDivisionPopUp, setBasicDivisionPopUp] = useState({
    title: '',
    content: '',
    footerContent: '',
    show: false,
    height: '443px'
  })

  const getLessonsFromTopicsList = () => {
    const extractLessonsFromType = (type) => {
      if (type && type.length) {
        return type.reduce((lessons, item) => {
          if (item.lessons && item.lessons.length) {
            lessons.push(...item.lessons);
          }
          return lessons;
        }, []);
      }
      return [];
    };
    const allLessons = [
      ...extractLessonsFromType(lessonByTopic?.[uiData[applictionName].lessonesListType[0]]),
      ...extractLessonsFromType(lessonByTopic?.[uiData[applictionName].lessonesListType[1]]),
      ...extractLessonsFromType(lessonByTopic?.[uiData[applictionName].lessonesListType[2]])
    ];
    return allLessons
  }

  const ApplyBasicDivision = () => {
    if (lessonMode) {
      let hasSubmission =
        Object.values(teams).some(entry => entry.submissionStatus === submissionStatusTextEnum.hasSubmission || entry.submissionStatus === submissionStatusTextEnum.finalScored) ||
        Object.values(users).some(entry => entry.submissionStatus === submissionStatusTextEnum.hasSubmission || entry.submissionStatus === submissionStatusTextEnum.finalScored)
      if (hasSubmission) {
        let title = texts.payAttention
        let content = texts.thereAreStudentsWhoStartedWorking
        setPopup(
          <WarningPopup headerTitle={texts.dividingTeams} title={title} content={content}  >
            <>
              <div className={classes.BtnsContainer}>
                <button className={`${classes.Btn} ${classes.BtnCancel}`} onClick={() => setPopup(null)}>{texts.cancel}</button>
                <button className={`${classes.Btn} ${classes.BtnOk}`} onClick={() => { confirmApplyBasicDivision(); setPopup(null); }}>{texts.ok}</button>
              </div>
            </>
          </WarningPopup>)
      }
      else {
        confirmApplyBasicDivision()
      }
    }
    else {
      setCurrentStep(ApplyBasicDivisionStepsEnum.lessonList)
      setBasicDivisionPopUp(prevState => ({
        ...prevState,
        title: texts.payAttention,
        content: [
          texts.markStartedLessons,
          <img src={warnIcon} alt="Warning" style={{ marginBottom: '-5px' }} />,
          <br />,
          texts.deletePersonalWork,
          <br />,
          texts.unmarkTheLessonsThatHaveAlreadyBeenStudied
        ], show: true,
        height: '443px'
      }))
    }
  }

  const confirmApplyBasicDivision = () => {
    setPopup(null)
    changeRange([{ id: lessonId }])
  }

  const changeRange = (filteredLesson) => {
    setLoading(true);
    const lessonParticipantChangeRangeInput = {
      studyGroupId: studyGroupId,
      lessonsId: filteredLesson.map((lesson) => lesson.id)
    }
    lessonParticipantsApi.lessonParticipantsChangeRangePost({ lessonParticipantChangeRangeInput }, (error, resdata, response) => {
      if (error) {
        baseDispatch(throwApiError({ userMessage: texts.errorDeleteStudentFromTeam, error: error, message: "lessonParticipantsAddPost " + error.message, level: 2, component: "Teams", line: 261 }))
      }
      else {
        let problematicList, lessonsWithNoBasicDivision

        if (!lessonMode) {
          problematicList = filteredLesson.filter(lesson => lesson.hasSubmissions === true);
          lessonsWithNoBasicDivision = getLessonsFromTopicsList().filter(
            (lesson) => !filteredLesson.some((filteredLesson) => filteredLesson.id === lesson.id)
          );

          setBasicDivisionPopUp(prevState => ({
            ...prevState,
            title: texts.lessonsWithNoBasicDivisionTitle,
            content: lessonsWithNoBasicDivision.length ? texts.goToEditTeams : '',
            footerContent: '',
            show: true,
            height: '268px'
          }))

          let studyGroupData = courses?.find(c => c.id === id);
          const unSuccessListNames = lessonsWithNoBasicDivision?.map(item => item.name).join(', ');
          const textHe = `${studyGroupData?.name} - ${texts.noDivisionIntoTeamsHe} ${unSuccessListNames} `
          const textAr = `${studyGroupData?.name} - ${texts.noDivisionIntoTeamsAr} ${unSuccessListNames} `
          const textEn = `${studyGroupData?.name} - ${texts.noDivisionIntoTeamsEn} ${unSuccessListNames} `
          if (unSuccessListNames)
            handleNotification(textHe, textAr, textEn)
        }
        else {
          setBasicDivisionPopUp(prevState => ({
            ...prevState,
            title: texts.copiedSuccessfully,
            content: '',
            footerContent: '',
            show: true,
            height: '268px'
          }))
        }
        setUnSuccsesList(lessonsWithNoBasicDivision)
        setCurrentStep(ApplyBasicDivisionStepsEnum.lessonsWithNoBasicDivision)
        setLoading(false);
        setDisplayLastChange(true)
      }
    })
  }

  const completeBasicDivision = (lessonId) => {
    if (!lessonMode) {
      if (!lessonId)
        navigate(`${homeUrl}/${PathRouter.LEARNING_TRACKING}/${id}/${PathRouter.TEAMS}/${getLessonsFromTopicsList()[0].id}`)
      else
        navigate(`${homeUrl}/${PathRouter.LEARNING_TRACKING}/${id}/${PathRouter.TEAMS}/${lessonId}`)

    }
    setBasicDivisionPopUp(prevState => ({
      ...prevState,
      footerContent: '',
      show: false,
      height: '443px'
    }))
    fetchTeams()
    setAnableBasicDivisionButton(false)
  }

  const closePopup = () => {
    setBasicDivisionPopUp(prevState => ({
      ...prevState,
      show: false,
      height: '443px'
    }))
  }

  const handleNotification = (textHe, textAr, textEn) => {
    const link = `${id}`;
    const contents = cretaeMessageContent(textHe, textAr, textEn, link);
    const messageAddOrUpdateInput = {
      refObjectId: applicationId,
      refObjectType: ObjectTypeNamesEnum.Application,
      targetObjectId: user.id,
      targetObjectType: ObjectTypeNamesEnum.User,
      contents: contents
    }
    messagesApi.messagesAddPost({ messageAddOrUpdateInput }, (error, resdata, response) => {
      if (error) {
        dispatch(throwApiError({ userMessage: texts.MessagePostError, error: error, statusCode: response?.statusCode, message: "messagesAddPost " + error.message, level: 1, component: "SummativeAssessment", line: 145 }))
      }
      else {
        console.log('message sent successfully!')
      }
    })
  }

  return (
    <>
      <div
        className={`${classes.ApplyBasicDivision} ${(!anableBasicDivisionButton || (!lessonMode && !hasUsersInTeams())) && classes.DisableBtn}`} onClick={ApplyBasicDivision}>
        {lessonMode ? texts.applyBasicDivisionForLesson : texts.applyBasicDivision}
      </div>
      {uiData && basicDivisionPopUp.show &&
        < WarningPopup setPopup={closePopup} headerTitle={texts.applyBasicDivision} title={basicDivisionPopUp.title} footerContent={basicDivisionPopUp.footerContent} content={basicDivisionPopUp.content} dropClass={classes.LineHeight} myHeight={basicDivisionPopUp.height} myWidth={'554px'}>
          {currentStep == ApplyBasicDivisionStepsEnum.lessonList && <LessonsList lessonsList={getLessonsFromTopicsList()} changeRange={changeRange}></LessonsList>}
          {currentStep == ApplyBasicDivisionStepsEnum.lessonsWithNoBasicDivision && <>{unSuccsesList?.length ?
            <ProblematicList lessonMode={lessonMode} list={unSuccsesList} complete={completeBasicDivision}></ProblematicList> :
            <div className={classes.Ok} onClick={() => completeBasicDivision(lessonId)}> {lessonMode ? texts.ok : texts.goToLessonDistribution}</div>
          }</>
          }
        </WarningPopup >}
    </>
  );
};
export default ApplyBasicDivision